module.exports = __webpack_public_path__ + "img/ic-environment.738f622e.svg";